module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-jack.6245db13.svg";